import { InnerhivePlusText } from '../components/InnerhivePlusText';
import { PaywallAwareButton } from '../components/PaywallAwareButton';
import { createUseStyles } from 'react-jss';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useState } from 'react';
import { useSubscription } from '@meraki-internal/state';
import { CommunityModelFactory } from './CommunityModelFactory';
import { CommunityInviteModal } from '../community/CommunityInviteModal';

const useStyles = createUseStyles({
    button: {
        height: 40
    }
});

export const InviteCoOwnerButton: React.FC = () => {
    const classes = useStyles();

    const factory = useInstance(CommunityModelFactory);
    useSubscription(() => factory);
    const community = factory.forActiveCaremap();

    const [isInviteModalOpen, setIsInviteModalOpen] = useState<boolean>(false);

    return (
        <>
            <PaywallAwareButton
                fill="outline"
                expand="block"
                data-id="invite-co-owner-button"
                className={classes.button}
                // until the community model loads, getCoOwners() is empty and would briefly
                // render an unlocked button for an owner already at the limit — disable until loaded
                disabled={!community.isLoaded()}
                onClick={() => setIsInviteModalOpen(true)}
                triggerSource="co-owner invite"
                requiresInnerhivePlus={(limits) => community.addCoOwnerRequiresInnerhivePlus(limits)}
                innerhivePlusMessage={<>Get <InnerhivePlusText/> to invite more co-owners</>}
            >
                <>Invite Co-Owner</>
            </PaywallAwareButton>

            <CommunityInviteModal
                isOpen={isInviteModalOpen}
                access="co-owner"
                closeHandler={() => setIsInviteModalOpen(false)}
            />
        </>
    );
};
